import { virtualAssistanceNPCConfig } from "@constants/virtualAssistanceConstants";
import {
  AvailablePreTestConfigurationOptions,
  TestType,
  EyeType,
  TestConfiguration,
  TestCategory,
  TestUIConfiguration,
} from "types/testTypes";
import { CATEGORY_VERSION_MAP, TEST_TYPE_VERSION_MAP } from "../versionConstants";
import {
  AVAILABLE_EYE_OPTIONS_BINOCULAR,
  AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS_ENGLISH_ONLY,
  CALIBRATION_TOGGLE_OPTION_NEW_APK,
} from "../configurationHelperConstants";

export const availableNPCTTestConfigurationOptions: AvailablePreTestConfigurationOptions = {
  testTypes: {
    configurationFieldName: "testType",
    choices: [
      {
        value: TestType.NearPointConvergence,
        validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.NearPointConvergence],
      },
    ],
    isMandatory: true,
    validSinceVersion: CATEGORY_VERSION_MAP[TestCategory.BinocularVision],
  },
  eyeConfigurationOptions: {
    ...AVAILABLE_EYE_OPTIONS_BINOCULAR,
    toggleCalibrationOption: { ...CALIBRATION_TOGGLE_OPTION_NEW_APK },
  },
  testSpeedOptions: null,
  languageOptions: null,
  virtualAssistantOptions: { ...AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS_ENGLISH_ONLY },
};

export const npctTestConfiguration: TestConfiguration = {
  name: TestCategory.BinocularVision,
  testType: TestType.NearPointConvergence,
  eyeConfiguration: {
    eyeType: EyeType.BothEye,
    isCalibrationNeeded: true,
    autoPauseForGaze: false,
    isTwoScreenFixationEnabled: false,
    isBackToBackEyeTest: false,
  },
  testSpeed: null,
  testLanguage: null,
  virtualAssistanceConfig: virtualAssistanceNPCConfig,
  isPressToStartEnabled: true,
  extraData: null,
};

export const npctUIConfiguration: TestUIConfiguration = {
  showProgressBar: true,
  instructions: null,
};
